import React, { Component } from "react";
import "styled-components/macro";

import guessMyDevice from "./utils/guess-my-device";

export default class CardCompanyValues extends Component {

  device = guessMyDevice();

  render() {
    return (
      <div
        css={`
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: ${this.device !== 'mobile' ? '1%' : '50px 0 0'};
          width: ${this.device !== 'mobile' ? '28%' : '100%'};
          /* background: gray; */
          /* min-width: 326px; */
          /* border: 1px solid #cfcfd3; */
          /* border-radius: 4px; */
          /* min-height: 250px; */
          &:last-child {
            margin: 0 0 0 0;
          }
        `}
      >
        <img src={this.props.imgSrc} alt={`icon${this.props.title}`}
          width={this.device !== 'mobile' ? 100 : 70}
          height={this.device !== 'mobile' ? 100 : 70}
        />
        <div
          css={`
            margin-top: ${this.device !== 'mobile' ? '30px' : '15px'};
            font-size: 18px;
            font-weight: bold;
            color: #02021d;
          `}
        >
          {this.props.title}
        </div>
        <div
          css={`
            margin-top: 8px;
            line-height: 141%;
            font-size: ${this.device !== 'mobile' ? '16px' : '14px'};
            text-align: center;
            opacity: 0.6;
            color: #02021d;
            -webkit-font-smoothing: antialiased;
-moz-osx-font-smoothing: grayscale;
            font-weight: ${this.device !== 'mobile' ? '500' : '400'};
          `}
        >
          {this.props.blurb}
        </div>
      </div>
    );
  }
}
